"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HeroText = require("./HeroText.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _text = require("../../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources

/**
 * Hero text is not currently used in any cake app designs.
 * This element is for parity with marketing.
 * If used, this is generally intended to be over a hero image, or other high impact area.
 */
// intentionally left as a functional component
var HeroText = function HeroText(_ref) {
  var alignment = _ref.alignment,
      bold = _ref.bold,
      children = _ref.children,
      className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      italic = _ref.italic,
      underline = _ref.underline,
      zeroPadding = _ref.zeroPadding;
  return /*#__PURE__*/_react.default.createElement(_HeroText.StyledHeroText, {
    alignment: alignment,
    className: className,
    bold: bold,
    colorTheme: colorTheme,
    dataTestId: dataTestId,
    italic: italic,
    underline: underline,
    zeroPadding: zeroPadding
  }, children);
};

HeroText.propTypes = {
  /** alignment hook */
  alignment: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** flag for bolding text */
  bold: _propTypes.default.bool,

  /** children components or just plain old text */
  children: _propTypes2.default.children.isRequired,

  /** className hook for styling */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the text.
   undefined,
   'default'
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** flag for italicising text */
  italic: _propTypes.default.bool,

  /** flag for underlining text */
  underline: _propTypes.default.bool,

  /** flag to remove default padding */
  zeroPadding: _propTypes.default.bool
};
HeroText.defaultProps = {
  alignment: undefined,
  bold: false,
  className: '',
  colorTheme: 'overDark',
  italic: false,
  underline: false,
  zeroPadding: false
};
var _default = HeroText;
exports.default = _default;